const FUSION_HUB_SOURCE = /^FusionHub:(\d+)$/;

export const toFusionHubSource = (integrationId: number | string): string =>
	`FusionHub:${integrationId}`;

export const parseFusionHubSource = (
	source: string | undefined,
): number | undefined => {
	const id = Number(source?.match(FUSION_HUB_SOURCE)?.[1]);
	return id > 0 ? id : undefined;
};
